import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  params: any;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  params: {}
};

export const memoReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {    
    case Constants.GLOBAL_EVENT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_EVENT_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
